export default "__VITE_ASSET__DFD3jB6p__"